import { render, staticRenderFns } from "./SchoolFooterSection.vue?vue&type=template&id=69e01204&"
import script from "./SchoolFooterSection.vue?vue&type=script&lang=js&"
export * from "./SchoolFooterSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports